// extracted by css-extract-rspack-plugin
export default {"d-contents":"RailsPartial-module__d-contents__ndI3zHZ"};